var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"open":_vm.open},on:{"close":function($event){return _vm.$emit('close')}}},[_c('template',{slot:"title"},[_vm._v(" Check In Code ")]),_c('template',{slot:"content"},[_c('checkin-code',{attrs:{"data":_vm.location}})],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }